export function convert24HourTo12HourTime(militaryTime: string): string {
  const hours = parseInt(militaryTime.slice(0, 2), 10);
  const minutes = militaryTime.slice(2);
  if (hours === 12) {
    return `${hours}:${minutes} PM`;
  }
  if (hours === 0) {
    return `${hours + 12}:${minutes} AM`;
  }
  if (hours === 24) {
    return `${hours - 12}:${minutes} AM`;
  }
  if (hours < 12) {
    return `${hours}:${minutes} AM`;
  }
  if (hours > 12) {
    return `${hours - 12}:${minutes} PM`;
  }
  return `There was an error converting time:${militaryTime}.`;
}

export function createFormatedStoreHoursObject(
  storeHours: string,
  militaryTimeOutput = false,
): { open: string; close: string } {
  // Ex store hours arg '0900-2100' to {open:0900, close:2100} or {open:9:00 AM, close close 9:00 PM}
  const openCloseTimeArray = storeHours.split('-');
  // returns time object with open and close time in military or 12-hour time
  return {
    open: militaryTimeOutput
      ? openCloseTimeArray[0]
      : convert24HourTo12HourTime(openCloseTimeArray[0]),
    close: militaryTimeOutput
      ? openCloseTimeArray[1]
      : convert24HourTo12HourTime(openCloseTimeArray[1]),
  };
}

export function getHoursFromMilitaryTime(militaryTime: string, outputWithLeadingZero = false) {
  // for a given input "0900", return
  const hours = militaryTime.slice(0, 2);
  if (outputWithLeadingZero) {
    return Number(hours);
  }
  if (hours[0] === '0') {
    return Number(hours[1]);
  }
  return Number(hours);
}

export function getDayOfWeekWithOffset(offset?: number, allLowerCaseOutput = true): any {
  const now = new Date();
  if (offset) {
    const offsetDate = new Date(now);
    offsetDate.setDate(offsetDate.getDate() + offset);
    return offsetDate.toDateString().slice(0, 3).toLowerCase();
  }
  return now.toDateString().slice(0, 3).toLowerCase();
}
